import { render, staticRenderFns } from "./PromotionShippingCondition.vue?vue&type=template&id=55346caa&scoped=true&"
import script from "./PromotionShippingCondition.vue?vue&type=script&lang=js&"
export * from "./PromotionShippingCondition.vue?vue&type=script&lang=js&"
import style0 from "./PromotionShippingCondition.vue?vue&type=style&index=0&id=55346caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55346caa",
  null
  
)

export default component.exports